function* clientIdMaker(init: number = 0) {
  let id = init;
  while (true) {
    yield --id;
  }
}
const clientIdGenerator = clientIdMaker();

export function generateClientId() {
  return clientIdGenerator.next().value;
}

export function isClientId(id: number) {
  return id < 0;
}



// WEBPACK FOOTER //
// ./frontend/src/lib/generateClientId.ts